import React from 'react';
import {
  Alert,
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import ReactLoading from 'react-loading';
import mainHelper, { apiCall } from '../../helpers/MainHelper';
import './ModalStyles.css';

const emptySupplier = () => ({
  title: '',
  tax_no: '',
  tax_district: '',
  name: '',
  phone: '',
  email: '',
  address: '',
});

class QuickSupplierModal extends React.Component {
  state = {
    formData: emptySupplier(),
    loading: false,
    errors: {},
  };

  componentDidUpdate(previousProps) {
    if (this.props.isOpen && !previousProps.isOpen) {
      this.setState({ formData: emptySupplier(), errors: {}, loading: false });
    }
  }

  handleChange = (event) => {
    const { id, value } = event.target;
    event.target.classList.remove('is-invalid');
    this.setState((previousState) => ({
      formData: {
        ...previousState.formData,
        [id]: value,
      },
      errors: {
        ...previousState.errors,
        [id]: undefined,
      },
    }));
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { formData } = this.state;
    const errors = {};

    if (!formData.title.trim()) errors.title = 'Tedarikçi ünvanı gereklidir.';
    if (!formData.tax_no.trim()) errors.tax_no = 'Vergi/T.C. numarası gereklidir.';
    if (!formData.tax_district.trim()) errors.tax_district = 'Vergi dairesi gereklidir.';

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const supplierData = new FormData();
    Object.entries(formData).forEach(([key, value]) => supplierData.append(key, value));
    supplierData.append('is_supplier', '1');
    supplierData.append('save_parasut', '0');

    this.setState({ loading: true, errors: {} });

    try {
      const response = await apiCall('business/customer/add', 'post', supplierData);

      if (!response?.data?.id) {
        throw new Error('Oluşturulan tedarikçi bilgisi alınamadı.');
      }

      mainHelper.toastMessage('success', response.message || 'Tedarikçi başarıyla eklendi.');
      this.props.onCreated(response.data);
    } catch (error) {
      const validationErrors = error?.response?.data?.errors || {};
      document.querySelectorAll('#quickSupplierForm .text-danger').forEach((element) => element.remove());
      document.querySelectorAll('#quickSupplierForm .is-invalid').forEach((element) => element.classList.remove('is-invalid'));
      this.setState({ errors: validationErrors });

      if (!error?.response) {
        mainHelper.toastMessage('error', error.message || 'Tedarikçi eklenirken bir hata oluştu.');
      }
    } finally {
      this.setState({ loading: false });
    }
  };

  renderError = (field) => {
    const error = this.state.errors[field];
    if (!error) return null;

    return (
      <small className="d-block mt-1" style={{ color: '#dc3545' }}>
        {Array.isArray(error) ? error[0] : error}
      </small>
    );
  };

  render() {
    const { isOpen, toggle } = this.props;
    const { formData, loading } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        toggle={loading ? undefined : toggle}
        size="lg"
        className="modern-modal"
        backdrop="static"
        centered
      >
        <ModalHeader toggle={loading ? undefined : toggle} className="modal-header-gradient">
          <div className="modal-title-wrapper">
            <div className="modal-icon-wrapper">
              <i className="fa fa-truck"></i>
            </div>
            <div>
              <h5 className="mb-0">Hızlı Tedarikçi Ekle</h5>
              <small>Kayıt tamamlanınca bu satıra otomatik seçilir</small>
            </div>
          </div>
        </ModalHeader>
        <Form id="quickSupplierForm" onSubmit={this.handleSubmit}>
          <ModalBody className="modal-body-modern">
            <Alert color="info" className="py-2">
              Yıldızlı alanlar kayıt için zorunludur. Diğer bilgileri daha sonra tedarikçi detayından tamamlayabilirsiniz.
            </Alert>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="title" className="modern-label">Firma / Tedarikçi Ünvanı *</Label>
                  <Input
                    id="title"
                    value={formData.title}
                    onChange={this.handleChange}
                    className="modern-input"
                    placeholder="Örn. ABC Otomotiv Ltd. Şti."
                    autoFocus
                  />
                  {this.renderError('title')}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="tax_no" className="modern-label">Vergi / T.C. No *</Label>
                  <Input
                    id="tax_no"
                    value={formData.tax_no}
                    onChange={this.handleChange}
                    className="modern-input"
                    placeholder="Vergi veya T.C. numarası"
                  />
                  {this.renderError('tax_no')}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="tax_district" className="modern-label">Vergi Dairesi *</Label>
                  <Input
                    id="tax_district"
                    value={formData.tax_district}
                    onChange={this.handleChange}
                    className="modern-input"
                    placeholder="Vergi dairesi"
                  />
                  {this.renderError('tax_district')}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="name" className="modern-label">Yetkili Adı</Label>
                  <Input
                    id="name"
                    value={formData.name}
                    onChange={this.handleChange}
                    className="modern-input"
                    placeholder="Yetkili kişi"
                  />
                  {this.renderError('name')}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="phone" className="modern-label">Telefon</Label>
                  <Input
                    id="phone"
                    value={formData.phone}
                    onChange={this.handleChange}
                    className="modern-input"
                    placeholder="05XX XXX XX XX"
                  />
                  {this.renderError('phone')}
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label for="email" className="modern-label">E-posta</Label>
                  <Input
                    id="email"
                    type="email"
                    value={formData.email}
                    onChange={this.handleChange}
                    className="modern-input"
                    placeholder="ornek@firma.com"
                  />
                  {this.renderError('email')}
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup className="mb-0">
                  <Label for="address" className="modern-label">Adres</Label>
                  <Input
                    id="address"
                    type="textarea"
                    rows="2"
                    value={formData.address}
                    onChange={this.handleChange}
                    className="modern-input"
                    placeholder="Adres"
                  />
                  {this.renderError('address')}
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter className="modal-footer-modern">
            <Button type="button" color="light" onClick={toggle} disabled={loading}>
              Vazgeç
            </Button>
            <Button type="submit" color="info" disabled={loading}>
              {loading ? (
                <span className="d-flex align-items-center">
                  <ReactLoading type="spin" width="18px" height="18px" color="#ffffff" />
                  <span className="ml-2">Kaydediliyor...</span>
                </span>
              ) : (
                <><i className="fa fa-check mr-2"></i>Kaydet ve Seç</>
              )}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

export default QuickSupplierModal;
